// create/post
export const CREATE_RISK_PROFILE_REQUEST = "CREATE_RISK_PROFILE_REQUEST";
export const CREATE_RISK_PROFILE_SUCCESS = "CREATE_RISK_PROFILE_SUCCESS";
export const CREATE_RISK_PROFILE_FAIL = "CREATE_RISK_PROFILE_FAIL";

// get
export const RISK_PROFILE_REQUEST = "RISK_PROFILE_REQUEST";
export const RISK_PROFILE_SUCCESS = "RISK_PROFILE_SUCCESS";
export const RISK_PROFILE_FAIL = "RISK_PROFILE_FAIL";

// find
export const FIND_RISK_PROFILE_REQUEST = "FIND_RISK_PROFILE_REQUEST";
export const FIND_RISK_PROFILE_SUCCESS = "FIND_RISK_PROFILE_SUCCESS";
export const FIND_RISK_PROFILE_FAIL = "FIND_RISK_PROFILE_FAIL";

// update/put
export const UPDATE_RISK_PROFILE_REQUEST = "UPDATE_RISK_PROFILE_REQUEST";
export const UPDATE_RISK_PROFILE_SUCCESS = "UPDATE_RISK_PROFILE_SUCCESS";
export const UPDATE_RISK_PROFILE_FAIL = "UPDATE_RISK_PROFILE_FAIL";

// delete
export const DELETE_RISK_PROFILE_REQUEST = "DELETE_RISK_PROFILE_REQUEST";
export const DELETE_RISK_PROFILE_SUCCESS = "DELETE_RISK_PROFILE_SUCCESS";
export const DELETE_RISK_PROFILE_FAIL = "DELETE_RISK_PROFILE_FAIL";

export const CLEAR_ERROR = "CLEAR_ERROR";